import { Link } from "react-router-dom";
import type { Manga } from "@/mocks/manga";
import { formatViews } from "@/mocks/manga";

export default function MangaCard({ manga, rank }: { manga: Manga; rank?: number }) {
  return (
    <Link
      to={`/article/${manga.id}`}
      className="group block bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-colors"
    >
      <div className="relative aspect-[2/3] overflow-hidden">
        <img
          src={manga.cover}
          alt={`${manga.title}漫画封面`}
          title={manga.title}
          loading="lazy"
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {manga.isHot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-semibold">
            热门
          </span>
        )}
        {manga.isNew && (
          <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-foreground-950 text-xs font-semibold">
            新作
          </span>
        )}
        <span
          className={`absolute bottom-2 right-2 px-2 py-0.5 rounded-md text-xs font-medium ${
            manga.status === "完结"
              ? "bg-secondary-500 text-background-50"
              : "bg-background-50/90 text-primary-600"
          }`}
        >
          {manga.status}
        </span>
        {rank !== undefined && (
          <span className="absolute bottom-2 left-2 w-7 h-7 flex items-center justify-center rounded-md bg-foreground-950/85 text-background-50 font-heading text-sm">
            {rank + 1}
          </span>
        )}
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 truncate">{manga.title}</h3>
        <div className="mt-1 flex flex-wrap gap-1">
          {manga.categories.map((c) => (
            <span key={c} className="text-[11px] text-primary-600 bg-primary-100 rounded px-1.5 py-0.5">
              {c}
            </span>
          ))}
        </div>
        <div className="mt-2 flex items-center justify-between text-xs text-foreground-600">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formatViews(manga.views)}
          </span>
          <span className="flex items-center gap-1 text-accent-600">
            <i className="ri-star-fill"></i>
            {manga.rating.toFixed(1)}
          </span>
        </div>
      </div>
    </Link>
  );
}